import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "container-fluid p-0 m-0" }
const _hoisted_2 = { class: "col-11 d-lg-flex align-items-center mx-auto justify-content-center position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "ms-auto d-flex align-items-left justify-content-left col-2 col-md-2 mx-4 searchbox"
}
const _hoisted_4 = {
  key: 0,
  class: "ms-3 text-nowrap px-4 d-none d-lg-block"
}
const _hoisted_5 = { class: "navright d-flex ms-auto align-items-lg-center align-items-md-top mt-lg-0 mt-md-3" }
const _hoisted_6 = {
  key: 0,
  class: "ms-auto me-2"
}
const _hoisted_7 = { href: "/login" }
const _hoisted_8 = {
  key: 0,
  class: "hphtop"
}

import { onBeforeMount, onMounted, ref } from 'vue';
import SearchBox from '@/components/elements/SearchBox.vue';
// import ShoppingCart from '@/components/elements/ShoppingCart.vue';
import LanguageSelector from '@/components/elements/LanguageSelector.vue';
import TopNavBar from '@/components/TopNavBar.vue';
import TopNavBarUser from '@/components/TopNavbarUser.vue';
import MainDarkBarTop from '@/components/mainpage/MainDarkBarTop.vue';
// import MainDarkCustomBarTop from '@/components/mainpage/MainDarkCustomBarTop.vue';
import MainDarkLandingBarTop from '@/components/mainpage/MainDarkLandingBarTop.vue';
import MainHeader from '@/components/mainpage/MainHeader.vue';
import MainSubHeader from '@/components/mainpage/MainSubHeader.vue';
import { getCookie } from "@/common/common.js";
import { userMainStore } from '@/store/userMainStore';
import { userFilterStore } from '@/store/userFilterStore';
import FooterDark from '@/components/layout/FooterDark.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBarMenu',
  props: {
	msg: String
},
  setup(__props) {

const main = userMainStore();
const filter = userFilterStore();

let loggedin = false;
let fixedbarf = ref(null);
let homepageheaderf = ref(null);
let promobarf = ref(null);
// let promocustombarf = ref(null);
let landingcustombarf = ref(null);
let vh = ref(0);



onBeforeMount(
	async () => {
		if (getCookie("uid")) {
			loggedin = true;
		}
	});


onMounted(
	async () => {
		fixedMenu();
		mobileOnly();
	});

const mobileOnly = () => {
	if (!window.matchMedia("(max-width: 992px)").matches) return;
	let elements = document.getElementsByClassName("tt-dropdown-item");
	let navbar = document.querySelector(".navbar-collapse.collapse");
	let navMobileFunction = function() {
		navbar.classList.remove("show");
		document.querySelector("button.navbar-toggler").setAttribute("aria-expanded", "false")
	};
	for (let i = 0; i < elements.length; i++) {
		elements[i].addEventListener('click', navMobileFunction, false);
	}
}

const fixedMenu = () => {
	vh.value = window.innerHeight / 2;
	let offset = homepageheaderf?.value.offsetHeight;
	document.addEventListener('scroll', function() {
		setTimeout(function() {
			var timeoutId = null;
			if (timeoutId) clearTimeout(timeoutId);
			timeoutId = setTimeout(fixedBar, 30);
		});
	});

	function fixedBar() {
		if (window.scrollY > vh.value + offset) {
			fixedbarf.value?.classList.remove("stickyout");
			fixedbarf.value?.classList.add("sticky");
		} else if (window.scrollY < 10 /*offset + vh.value*/ ) {
			fixedbarf.value?.classList.remove("sticky");
			fixedbarf.value?.classList.add("stickyout");

		}
	}
}

const doSearch = (s) => {
	document.location = '/d/search/' + s;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(main).isavailable)
      ? (_openBlock(), _createBlock(MainDarkBarTop, {
          key: 0,
          ref_key: "promobarf",
          ref: promobarf,
          class: "topbar"
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(MainDarkLandingBarTop, {
      ref_key: "landingcustombarf",
      ref: landingcustombarf,
      "xv-if": "!main.isavailable",
      class: "topbar"
    }, null, 512),
    _createElementVNode("div", {
      class: _normalizeClass(["navtop", [ _unref(main).isavailable? 'homepageheader' : 'nhpage' ]]),
      id: "homepageheader",
      ref_key: "homepageheaderf",
      ref: homepageheaderf
    }, [
      _createElementVNode("div", {
        class: "d-lg-flex col-12 align-items-lg-center mx-auto pt-2 align-items-md-top robotofonts maintop",
        ref_key: "fixedbarf",
        ref: fixedbarf,
        style: {"min-height":"66px"}
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TopNavBar, null, {
            search: _withCtx(() => [
              (!_unref(main).isavailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(SearchBox, {
                      onDoSearch: doSearch,
                      disablekeyup: "",
                      nopill: "",
                      noborder: "",
                      bottomborder: ""
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_unref(filter).isavailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light rounded-pill border px-5",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(filter).isopen=!_unref(filter).isopen))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "bi bi-sliders" }, null, -1),
                  _createTextVNode(" Filter", -1)
                ]))])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (!_unref(loggedin))
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createElementVNode("a", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass([{ 'bg-transparent border-0' : _unref(main).isavailable }, "fw-semibold btn btn-sm btn-light d-none sign-in-btn d-lg-block text-nowrap"])
                    }, _toDisplayString(_ctx.$t('menu.signin', 'Log In')), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(LanguageSelector, {
              class: "d-none d-lg-block",
              colorclass: "tt-text",
              top: ""
            }),
            (_unref(loggedin))
              ? (_openBlock(), _createBlock(TopNavBarUser, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512),
      (_unref(main).isavailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(MainHeader),
            _createVNode(MainSubHeader)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_router_view, {
      class: "view sidemain h-100",
      name: "sidemain"
    }),
    (!_unref(main).hidefooter)
      ? (_openBlock(), _createBlock(FooterDark, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})